/* eslint-env browser */

/**
 * Parallax support
 * 
 * Example:
 * 
 *  <div class="parallax-block">
 *      <img class="img-parallax" data-speed="-1" src="{{img_url @site.cover_image size="xl"}}" />
 *      <h2>WoW</h2>
 *  </div>
 * 
 */

(function (window, document) {
    $(window).on('load', function () {
        $('.img-parallax').each(function () {
            var img = $(this);
            var imgParent = $(this).parent();
            function parallaxImg() {
                var speed = img.data('speed');
                var imgY = imgParent.offset().top;
                var winY = $(this).scrollTop();
                var winH = $(this).height();
                var parentH = imgParent.innerHeight();
                var winBottom = winY + winH;
                if (winBottom > imgY && winY < imgY + parentH) {
                    var imgBottom = ((winBottom - imgY) * speed);
                    var imgTop = winH + parentH;
                    var imgPercent = ((imgBottom / imgTop) * 100) + (50 - (speed * 50));
                }
                img.css({
                    top: imgPercent + '%',
                    transform: 'translate(-50%, ' + -imgPercent + '%)'
                });
            }
            $(document).on({
                scroll: function () {
                    parallaxImg();
                }, ready: function () {
                    parallaxImg();
                }
            });
        });
    });
})(window, document);